import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys as calendarKeys } from "../../calendar/api/keys";
import { keys as topicsKeys } from "../../topics/api/keys";
import { keys } from "./keys";

async function completeReminder(reminderId: string) {
  const { data, error } = await apiClient
    .functions
    .invoke('complete-reminder', {
      body: {
        reminderId
      }
    })

  if (error) {
    throw error;
  }

  return data;
}

export default function useCompleteReminder() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (reminderId: string) => completeReminder(reminderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.lists() })
      queryClient.invalidateQueries({ queryKey: keys.upcomingAll() })
      queryClient.invalidateQueries({ queryKey: calendarKeys.list() })
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: topicsKeys.pendingSubTopics(currentSpace.id) })
      }
    }
  })
}